import CartDeliveryNote from "../info/CartDeliveryNote";
import CartSummary from "../info/CartSummary";
import CartDeliveryMessage from "../info/CartDeliveryMessage";
import CartOrder from "../input/CartOrder";
import CartPayment from "../input/CartPayment";
import LoadingDialog from "../../../general/dialog/DialogLoading";
import CartCheckoutButton from "../input/CartCheckoutButton";
import CartCheckoutError from "../info/CartCheckoutError";
import CartPaymentProcessor from "../input/CartPaymentProcessor";
import CartDelivery from "../input/CartDelivery";

const CartCheckout = ({ checkout }) => {

    return (
        <div className="cart-container">
            <CartPaymentProcessor checkout={checkout} />
            <CartCheckoutError checkout={checkout} />
            <LoadingDialog title="Completing Checkout" loading={checkout.isCheckoutLoading()} />
            <LoadingDialog title="Updating Order" loading={checkout.isOrderLoading()} />
            <div className="cart-header">
                <p className="cart-h1">Checkout</p>
                <CartDeliveryNote
                    orderLocation={checkout.getBPartnerLocation()}
                    availableDates={checkout.getAvailableDates()}
                    loading={checkout.isDeliveryDatesLoading()}
                    forPickUp={checkout.getDeliveryViaRule() === 'P'}
                />
            </div>
            <div className="cart-content">
                <div className="cart-column">
                    <div className="cart-section">
                        <p className="cart-h2">Order</p>
                        <CartOrder checkout={checkout} />
                    </div>
                    <div className="cart-section">
                        <p className="cart-h2">Delivery</p>
                        <CartDelivery checkout={checkout} />
                    </div>
                    <div className="cart-section">
                        <p className="cart-h2">Payment</p>
                        <CartPayment checkout={checkout} />
                    </div>
                </div>

                <div className="cart-column">
                    <div className="cart-section">
                        <p className="cart-h2">Summary</p>
                        <CartSummary checkout={checkout} />
                    </div>
                    <div className="cart-delivery">
                        <p className="cart-h2">Delivery Charge</p>
                        <CartDeliveryMessage checkout={checkout} />
                    </div>
                    <p className="cart-h2">Checkout</p>
                    <CartCheckoutButton
                        checkout={checkout}
                    />
                </div>
            </div>
        </div>
    )
}

export default CartCheckout;
